import { Final, Row } from './style';
import { Instagram, Whatsapp, Envelope } from 'react-bootstrap-icons';
import { CONTACTS, COMPANY_NAME, COMPANY_YEAR } from '../../constants';
import logo1 from '../../assets/images/logo1.png';

const Footer = () => {
  return (
    <footer role="contentinfo">
      <Row>
        <div>
          <img src={logo1} alt={`Logo ${COMPANY_NAME}`} width="60" height="60" />
          <h3>{COMPANY_NAME}</h3>
          <p>Gestão que gera resultados. Gestão que traz tranquilidade.</p>
        </div>
        <div>
          <h3>Redes sociais</h3>
          <a href={CONTACTS.INSTAGRAM} target="_blank" rel="noopener noreferrer" aria-label="Siga-nos no Instagram">
            <Instagram aria-hidden="true" />
            <span className="sr-only">Instagram</span>
          </a>
        </div>
        <div>
          <h3>Contato</h3>
          <a href={CONTACTS.WHATSAPP.url} target="_blank" rel="noopener noreferrer" aria-label="Entre em contato pelo WhatsApp">
            <Whatsapp aria-hidden="true" /> +55 47 9292-3530
          </a>
          <a href={`mailto:${CONTACTS.EMAIL}`} aria-label="Envie-nos um email">
            <Envelope aria-hidden="true" /> {CONTACTS.EMAIL}
          </a>
        </div>
      </Row>
      <Final>
        <p>
          © {COMPANY_YEAR} {COMPANY_NAME}. Todos os direitos reservados.
        </p>
        <p>
          Site desenvolvido por{' '}
          <a href={CONTACTS.LINKEDIN_DEV} target="_blank" rel="noopener noreferrer">
            @htferretti
          </a>
        </p>
      </Final>
    </footer>
  );
};

export default Footer;